import { useState, useEffect } from 'react';
import { convertEpochTime, getEndpoint, getUrl, showMultipleAuthor, setCmsSeoData, getAuthorCardTwo } from '../../../common/utils';
import { SocialShareTwo } from "../SocialShareTwo/SocialShareTwo";
import './VideoShowTwoAmp.css';
import { URL_PROTOCAL } from '../../Common/Constant';
import { PAGEBUILDER_URLS } from '../../Common/Constant';
import bcrypt from 'bcryptjs-react';
VideoShowTwoAmp.version = 1000;
VideoShowTwoAmp.lang = 'en';
VideoShowTwoAmp.langs = [
    'en'
];
VideoShowTwoAmp.setLang = (lang: any) => {
    VideoShowTwoAmp.lang = lang;
}

Object.defineProperty(VideoShowTwoAmp, 'name', {
    writable: true,
    value: 'VideoShowTwoAmp'
});

declare global {
    namespace JSX {
        interface IntrinsicElements {
            'amp-slikeplayer': any; // Declare amp-slikeplayer as any type
        }
    }
}

export function VideoShowTwoAmp(props: any) {
    const [videoShowData, setVideoShowData] = useState<any>({});
    const { showDateTime, showAuthor, showNewsAgency, authorCard } = props;

    let REQUEST_HOSTNAME: any = null;
    if (props && props.REQUEST_HOSTNAME) {
        REQUEST_HOSTNAME = props.REQUEST_HOSTNAME;
    }

    let REQUEST_URL: any = null;
    if (props && props.REQUEST_URL) {
        REQUEST_URL = props.REQUEST_URL;
    }

    const endpoint = getEndpoint(props, "MAIN");
    useEffect(() => {
        if (!endpoint.isSSR || !endpoint.SSRDataObj) {
            fetchComponentData();
        }
    }, [authorCard])

    const addExportedData = (object: any) => {
        if (typeof props.exportedKeys !== "undefined" && typeof props.exportedKeys.pid !== "undefined"
            && object.folderId != null && object.folderId != "") {
            props.exportedKeys.pid = object.folderId;
        }
        if (typeof props.exportedKeys !== "undefined" && typeof props.exportedKeys.sectionid !== "undefined"
            && object.id != null && object.id != "") {
            props.exportedKeys.sectionid = object.id;
        }
        if (typeof props.exportedKeys !== "undefined" && typeof props.exportedKeys.authorid !== "undefined"
            && typeof object.authors != "undefined" && object.authors.length > 0) {
            props.exportedKeys.authorid = object.authors[0].id;
        }
        if (typeof props.exportedKeys !== "undefined" && typeof props.exportedKeys.tags !== "undefined"
            && typeof object.kws != "undefined" && object.kws.length > 0) {
            const names = object.kws.map((item: any) => item.name).join(',');
            props.exportedKeys.tags = names;
        }
    }

    if (endpoint.isSSR && endpoint.SSRDataObj && videoShowData && Object.keys(videoShowData).length === 0
        && endpoint.SSRDataObj.items.length > 0) {
        setVideoShowData(endpoint.SSRDataObj.items[0])
        addExportedData(endpoint.SSRDataObj.items[0])
        setCmsSeoData(props, endpoint.SSRDataObj.items[0], "VideoShowAmp");
    }

    const fetchComponentData = () => {
        let videoUrl = getUrl(props, 0, false, "MAIN", true);

        let headerString = '?' + videoUrl.split("?")[1];
        headerString = bcrypt.hashSync(headerString, 6);
        const headers = { 'p-nonce': headerString };

        fetch(videoUrl, { headers: headers })
            .then(data => data.json())
            .then(val => {
                setVideoShowData(val.items[0])
                addExportedData(val.items[0])
                setCmsSeoData(props, val.items[0], "VideoShowAmp");
            })
    }

    const showCredits = () => {
        if (!videoShowData) {
            console.error('videoShowData is null or undefined');
            return <></>; // Return an empty fragment or some fallback UI
        }
        const { authors = [], pubInfo = {}, ag = [], upd } = videoShowData;
        const baseDomain = pubInfo ? pubInfo.baseDomain : '';

        let creditComponent = []
        const authorContent = showMultipleAuthor(authors, baseDomain)
        if (showAuthor && authorContent.length != 0) {
            creditComponent.push(authorContent)
        }
        if (showNewsAgency && ag && ag.length != 0) {
            creditComponent.push(ag)
        }
        let formattedDate = '';
        formattedDate = convertEpochTime(upd, 'updated', 'MMM DD, YYYY, HH:MM TZ') as string;



        if (formattedDate && showDateTime) {
            creditComponent.push(formattedDate)
        }
        let creditStr = creditComponent.join(" | ")
        return <><span className='articalShowAuthr' dangerouslySetInnerHTML={{ __html: creditStr }} /></>
    }
    const isDataAvailable = videoShowData && Object.keys(videoShowData).length > 0;
    let slikeId = '';

    if (isDataAvailable && videoShowData.media) {
        if (videoShowData.media.rmid === 10) {
            slikeId = 'yt' + videoShowData?.media?.id;
        } else {
            slikeId = videoShowData?.media?.id;
        }

    }
    return (
        <div>
            <div className="ampThemeTwoVideoShowPage">
                <div className='ampThemeTwoVideoFullBox'>
                    <div>
                        {
                            typeof window !== 'undefined' && PAGEBUILDER_URLS.some(url => window.location.origin.includes(url)) ?
                                <div className="ampThemeTwoVideoBox">
                                    {isDataAvailable && videoShowData?.media &&
                                        <div style={{ position: 'relative' }}>
                                            <img src={`/thumb/${videoShowData?.imageid.split('&')[0]}.cms?${videoShowData?.imageid.split('&')[1]}&width=1200&resizemode=4`} alt={videoShowData?.hl?.slice(0, 25)} title={videoShowData?.hl?.slice(0, 25)} />
                                            <div className='ampThemeTwoVideoIcon' style={{ height: '74px', width: '74px', position: 'absolute', left: '50%', top: '50%', color: '#ffffff', fill: '#ffffff' }}>

                                            </div>
                                            {/* <div className='ampVidoAuthDetails'>
                                                {showCredits()}
                                            </div> */}
                                        </div>
                                    }
                                </div>
                                :
                                <div>
                                    <amp-slikeplayer
                                        width="600"
                                        height="400"
                                        id="slikeVideo"
                                        data-apikey="test403web5a8sg6o9ug"
                                        data-videoid={slikeId}
                                        data-config="autoplay=true&skipad=false&playlist=true"
                                        data-iframe-src="https://tvid.in/sdk/amp/ampembed.html"
                                        layout="responsive">
                                    </amp-slikeplayer>
                                </div>

                        }


                    </div>

                </div>
                <div>
                    <div className="ampThemeTwoVideoTitle">
                        <div className="ampThemeTwoStoryHeading">
                            {videoShowData && videoShowData?.hl}
                        </div>
                    </div>
                    <div className='ampVidoAuthDetails'>
                        {showCredits()}
                    </div>
                    <div className='socialMediaWrap'>
                        <div className='ampThemeTwoCommonSocialListWrap'>
                            {
                                <SocialShareTwo
                                    shareUrl={URL_PROTOCAL + REQUEST_HOSTNAME + REQUEST_URL}
                                    shareText={videoShowData?.hl}
                                    showFacebook={true}
                                    showTwitter={true}
                                    showLinkedin={true}
                                    showWhatsapp={true}
                                    showPintrest={true}
                                />
                            }
                        </div>
                    </div>
                    <div className="ampThemeTwoVideoArticleSummary">
                        <div>
                            {videoShowData && videoShowData?.Story}
                        </div>

                        <div className='videoShowAuthorCard'>
                            {authorCard && videoShowData.authorDetails && Array.isArray(videoShowData.authorDetails) && videoShowData.authorDetails.length >= 0 &&
                                videoShowData.authorDetails.map((authorDetail: any) => (
                                    getAuthorCardTwo(props, authorDetail)
                                ))
                            }
                        </div>
                    </div>
                </div>

                <div className='tag_dnone'>

                </div>
            </div>
        </div>
    );
}
